import { Dimensions, Pressable } from "react-native"
import { View, Text } from "./Themed"
import Modal from "react-native-modal"
import { IconButton, useTheme } from "react-native-paper"
import DIcon from "./DIcon"
import { MaterialCommunityIcons } from "@expo/vector-icons"

interface options {
    isVisible: boolean,
    onBackdropPress: any,
    in: string,
    out: string
    style: {}
}
export default function DModal(op) {
    const theme = useTheme()
    const sty = op.delete ? { justifyContent: "center", alignItems: "center" } : {}
    return <Modal
        backdropOpacity={0.5}
        propagateSwipe
        style={{ margin: 0 }}
        isVisible={op.isVisible}
        onBackdropPress={() => op.onBackdropPress ? op.onBackdropPress() : op.close ? op.close() : () => { }}
        animationIn={op.delete ? "zoomIn" : op.in ? op.in : "slideInUp"}
        animationOut={op.delete ? "zoomOut" : op.out ? op.out : "slideOutDown"}>
        <View style={{
            width: Dimensions.get("window").width,
            bottom: 0,
            position: op.override ? "relative" : "absolute",
            backgroundColor: theme.dark ? "darkgray" : "white",
            padding: 20, ...sty, ...op.style
        }}>
            {op.showIcon !== undefined && <DIcon icon={op.showIcon == true ? "check-circle" : "close-circle"} size={80} color={op.showIcon == true ? "green" : "red"} />}
            {typeof op.close == "function" && <IconButton style={{ zIndex: 9000, position: "absolute", top: 0, right: 5 }} iconColor="red" icon={"close"} size={24} onPress={() => op.close()} />}
            {op.children}
            {typeof op.close == "function" && op.closeRow &&
                <Pressable style={({ pressed }) => [{ backgroundColor: pressed ? 'rgb(210, 230, 255)' : 'white' },]}
                    onPress={() => op.close()}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <DIcon inverse name="close" />
                        <Text style={{ padding: 10, fontSize: 16 }}>Close</Text>
                    </View>
                </Pressable>

            }
        </View>
    </Modal >

}